import React, { useState, useEffect } from 'react';
import { ChartArea, ColumnTitle, DonutRow, DonutHole, Legend, LegendItem } from './style';
import api from '../../services/api';
import { notifyApiError } from '../../services/apiError';
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend as ChartLegend } from "chart.js";
import { theme } from '../../styles/theme';
import IconSearchNotFound from "../../assets/icons/icons8-search-notfound.png";
import * as S from './maior-comercializacao-styles';
import { TaglinePSpan } from '../../styles/stylesTypography';
import { externalTooltipHandler } from './externalTooltip';
import { Loading } from '../loading';
import downloadFile from '../../utils/downloadFile';
import identifyErrorMenssage from '../../services/identifyErrorMenssage';
import { store } from 'react-notifications-component';
import IconXlsx from '../../assets/icons/icon-baixar-xlsx.png';

ChartJS.register(ArcElement, Tooltip, ChartLegend);

const CORES = [theme.colors.green.Verde_AgroReceita, '#50C681', '#63CC8F', '#7DD5A2', '#97DDB4'];

const AlvosMaisFrequentesPorPeriodo = ({ dtInicial, dtFinal, ...props }) => {

    const dataInicial = dtInicial;
    const dataFinal = dtFinal;

    const [dataGraph, setDataGraph] = useState([]);
    const [itens, setItens] = useState([]);
    const [showChart, setShowChart] = useState(false);
    const [hasData, setHasData] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);

    const gerarPDF = async () => {
        try {
            setLoadingPdf(true);
            window.onbeforeunload = () => 'Seu relatório está sendo gerado. Tem certeza que deseja sair?';

            const response = await api.post('/relatorios/alvos/pdf', {
                dtInicial: dataInicial,
                dtFinal: dataFinal,
            });

            if (response.data.downloadUrl) {
                await downloadFile(response.data.downloadUrl, 'relatorio-alvos.xlsx');
            }

            store.addNotification({
                title: "Sucesso!",
                message: "Relatório gerado com sucesso.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 6000,
                    onScreen: true
                }
            });
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } finally {
            setLoadingPdf(false);
            window.onbeforeunload = null;
        }
    }

    const updateData = async () => {
        setLoaded(false);

        try {
            const response = await api.post('/relatorios/alvos/grafico', {
                dtInicial: dataInicial,
                dtFinal: dataFinal,
            })

            const hasValues = response.data.data.pests.length > 0 && response.data.data.qtdReceitas.length > 0;
            setHasData(hasValues);

            setItens(response.data.data.pests.map((nome, i) => ({
                nome,
                percentual: response.data.data.qtdReceitas[i],
                cor: CORES[i % CORES.length],
            })));

            setDataGraph({
                labels: response.data.data.pests,
                datasets: [
                    {
                        data: response.data.data.qtdReceitas,
                        backgroundColor: CORES,
                        borderWidth: 1,
                    },
                ],
            });

            setShowChart(hasValues);
        } catch (error) {
            setHasData(false);
            notifyApiError(error, 'Falha ao carregar alvos mais frequentes.');
        } finally {
            setLoaded(true);
        }
    }

    useEffect(() => {
        updateData();
    }, [dtInicial, dtFinal])

    const loadingBox = (
        <div style={{ minHeight: '76px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Loading size="32px" color={theme.colors.green.Bandeira} noMargin />
        </div>
    );

    return (
        <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '14px' }}>
                <ColumnTitle style={{ margin: 0 }}>Alvos mais frequentes (%)</ColumnTitle>
                <a
                    onClick={() => !loadingPdf && gerarPDF()}
                    aria-disabled={loadingPdf}
                    style={{ cursor: loadingPdf ? 'not-allowed' : 'pointer', opacity: loadingPdf ? 0.4 : 1, display: 'flex', alignItems: 'center' }}
                >
                    <img width={18} src={IconXlsx} alt="Baixar XLSX" />
                </a>
            </div>

            {loaded === false || loadingPdf ? (
                loadingBox
            ) : showChart ? (
                <DonutRow>
                    <DonutHole>
                        <ChartArea style={{ margin: 0, padding: 0, minHeight: 0 }}>
                            <Doughnut
                                data={dataGraph}
                                height={76}
                                width={76}
                                options={{
                                    cutout: '72%',
                                    plugins: {
                                        legend: { display: false },
                                        tooltip: { enabled: false, external: externalTooltipHandler },
                                    },
                                    maintainAspectRatio: false,
                                }}
                            />
                        </ChartArea>
                    </DonutHole>

                    <Legend>
                        {itens.map((item) => (
                            <LegendItem key={item.nome} color={item.cor}>
                                <span className="dot" style={{ backgroundColor: item.cor }} />
                                <span className="label">{item.nome} <span className="percent">— {Math.round(item.percentual)}%</span></span>
                            </LegendItem>
                        ))}
                    </Legend>
                </DonutRow>
            ) : hasData === false ? (
                <S.ContainerItemNotFound>
                    <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

                    <TaglinePSpan color={theme.colors.gray.Cinza_2}>
                        Nenhuma informação encontrada!
                    </TaglinePSpan>
                </S.ContainerItemNotFound>
            ) : loadingBox}
        </>
    )
}

export default AlvosMaisFrequentesPorPeriodo;
